/******/
function initProductMobileSlider(slider) {
  slider.slick({
    arrows:true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    mobileFirst: true,
    prevArrow: '<button type="button" class="slick-prev product-slick-arrow" aria-label="Previous"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-f feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
    nextArrow: '<button type="button" class="slick-next product-slick-arrow" aria-label="Next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-f feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
  });
}

$(document).ready( function (){

  // get and set product variants
  if(productHandles != '' && $('#productVariants').length) {

    function getProductData(handle) {
      let url = '/products/'+ handle +'.json';
      return $.getJSON(url);
    }
    
    function UrlExists(url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
   if (http.status == 404){
     return http.status;
   }
       
} 

    function displayProductData(obj) {
      var htmlData = '', countAvailable = 1;
      $.each(obj, function(index, data) {
        //console.log(index+" - "+data.type+" - "+data.title+"****");
        if(data != undefined && data.type != 'Unavailable') {
          let productTitle = data.product.title;
          let productUrl = data.product.handle;
          let productImageSrc = data.product.image["src"];
          let className = (index > 4 && countAvailable > 5) ? 'js-hidden-color-swatch hide' : '';

          htmlData = htmlData + '<li class="product-swatch__item '+ className +'">'
            + '<a href="'+ productUrl +'" class="product-swatch__item--imagebox" title="'+ productTitle+'">'
            + '<img class="product-swatch__item--image" src="'+ productImageSrc +'"alt="'+ productTitle+'" width="60" height="60"></a></li>';
          countAvailable = countAvailable + 1;
        }
      });
      if(htmlData != '') {
        $("#productVariants").append(htmlData);
      }
      if(obj.length > 6 && countAvailable > 6 && htmlData != '') {
        let variantHiddenCnt = countAvailable - 6;
        $("#productVariants").append('<li><a href="javascript:void(0)" class="swatch-load-more js-toggle-color-swatch" data-count="'+ variantHiddenCnt +'"><span class="text">Show<br>More<br>('+ variantHiddenCnt +')</span></a></li>');
      }
    }

    var processItemsDeferred = [];
    var productHandleArr = productHandles.split(",");

    
    console.log(productHandleArr);
    productHandleArr = productHandleArr.filter(function(elem){return elem != activeHandle; })
  

    for (i=0; i < productHandleArr.length; i++) {
     var handlercheck = productHandleArr[i].replace(/"/g,'');
      console.log(handlercheck);
      if(productHandleArr[i] != '' && UrlExists(handlercheck)!=404) {
        processItemsDeferred.push(getProductData(handlercheck));
      }
     
    }

    $.when.apply($, processItemsDeferred).done(function(){
      // This callback will be called with multiple arguments,
      // one for each AJAX call
      // Each argument is an array with the following structure: [data, statusText, jqXHR]

      // Let's map the arguments into an object, for ease of use
      var productObj = [];
      if (processItemsDeferred.length > 1) {
        for(var i = 0, len = arguments.length; i < len; i++){
          productObj.push(arguments[i][0]);
        }
      }
      else {
        productObj.push(arguments[0]);
      }
      displayProductData(productObj);
    });
  }

  // product images slider
  const mainImagesSlick = $('.js-product-single__images-slider');
  const mqSmall = window.matchMedia('screen and (max-width: 767px)');

  var mediaSizeHandler = theme.Helpers.debounce(function() {
    if(mqSmall.matches) {
      initProductMobileSlider(mainImagesSlick);;
    }
  }, 50);

  mediaSizeHandler();

  //show more color swatches
  var variantContainerH = $('#productVariants').height();
  $('#productVariants').on('click', '.js-toggle-color-swatch', function() {
    $('.js-hidden-color-swatch').toggleClass('hide');
    if( !$(this).hasClass('active') ){
      $('.js-pdp-variant-loading').show();
    }
    $('#productVariants').css({
      'height': variantContainerH +'px'
    });

    setTimeout(function () {
      $('#productVariants').css({
        'height': '100%'
      });
      $('.js-pdp-variant-loading').hide()
    }, 2000);

    $(this).toggleClass('active');
    let count = $(this).data('count');
    var text = $(this).hasClass('active') ? "Fewer colors" : "Show<br>More<br>(" +count+ ")"
    $(this).html('<span>'+text+'</span>');
  });

  // Related products slider
  setTimeout(function () {
    $('.js-product-related-slider').slick({
      arrows: true,
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"/></svg></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
  }, 1000);


Shopify.Products.showRecentlyViewed( {
  howManyToShow: 8,
  onComplete: function() {
    if($(".js-recently-viewed-slider").length) {
      $(".product-recommendations__inner").removeClass('hide')
      $(".js-recently-viewed-slider").slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"/></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"/></svg></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: false
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }
          }
        ]
      });
    }

  }
});
Shopify.Products.recordRecentlyViewed();


// scroll to id
  $('.js-scrollToTabId').on('click', function() {
    let targetId = $(this).data('id');
    if(targetId != '') {
      if(!$('#'+targetId).hasClass('active')) {
        $('.product-tab__wrapper').removeClass('active');
        $('.js-acc-trigger').not('#'+targetId).removeClass('active');
        $('.js-acc-content').hide();
        $('#'+targetId).addClass('active');
        $('#'+targetId).children('.js-acc-trigger').addClass('active');
        $('#'+targetId).children('.js-acc-content').show();
      }
      $('html, body').animate({
          scrollTop: $('#'+targetId).offset().top
      }, 500);
    }
  });

// scroll to id for Visible Focus
  $('.js-scrollToTabId').keyup(function(event) {
    if (event.keyCode === 13) {
    let targetId = $(this).data('id');
    if(targetId != '') {
      if(!$('#'+targetId).hasClass('active')) {
        $('.product-tab__wrapper').removeClass('active');
        $('.js-acc-trigger').not('#'+targetId).removeClass('active');
        $('.js-acc-content').hide();
        $('#'+targetId).addClass('active');
        $('#'+targetId).children('.js-acc-trigger').addClass('active');
        $('#'+targetId).children('.js-acc-content').show();
      }
      $('html, body').animate({
          scrollTop: $('#'+targetId).offset().top
      }, 500);
    }
    }
  });  

  
const stringspr = $("body").attr("prodata-han") || "";
const substringspr = "springer";
const substringpadd = "padded";

if (stringspr.includes(substringspr)) {
  $(".product-tabs .product-tab__wrapper:nth-child(4)").show();
}
if (stringspr.includes(substringpadd)) {
  $(".product-tabs .product-tab__wrapper:nth-child(5)").show();
}
  
  
});

$( window ).on("load", function() {
//Porduct Zoom on click

  
  $( ".zoomImg" ).mouseout(function() {
        $(".product-single__media .feature-row__image").css({
      "z-index":"10"
    }); 
  });
  
  
  $(".product-single__media .feature-row__image").click(function(){
    $(this).css({
      "z-index":"auto"
    });
    
  });  

});